module.exports = __webpack_public_path__ + "img/farizon.347ea936.jpg";